import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BodyClass from 'components/shared/body-class'
import authActions from 'actions/auth/actions'
import placesActions from 'actions/places/actions'
import pick from 'lodash/pick'
import ProfileForm from './form'

const Profile = ({
  user,
  updateProfile,
  phone,
  place,
  avatar,
  address,
  description,
  website,
  places,
  fetchPlaceOptions,
  processing,
}) => {
  const componentObj = [
    { value: 'profile', title: 'Organizational Information' },
    { value: 'agreement', title: 'Agreement' },
  ]
  const [selectedComponent, setSelectedComponent] = useState('profile')
  const initialValues = { ...user, phone, avatar, description, website, place, address, accept: false }

  useEffect(() => { fetchPlaceOptions({ published: true }) }, [])

  const handleUpdate = (values) => {
    if (selectedComponent === 'profile') {
      updateProfile(values)
    }
  }
  return (
    <div className="w-full flex h-screen flex-col justify-start items-center md:my-10">
      <div className="bg-white w-4/12 lg:w-1/3 md:w-1/2 shadow-md rounded-lg">
        <BodyClass className="bg-gray-100" />
        <ul className="flex items-center bg-secondary-graywhite md:rounded-lg">
          {componentObj.map(({ value, title }, key) => (
            <li
              key={key}
              className={`w-1/2 text-center py-3 cursor-pointer ${value === selectedComponent &&
                'bg-white'}`}
              onClick={() => setSelectedComponent(value)}
            >
              {title}
            </li>
          ))}
        </ul>
        <ProfileForm
          onUpdate={handleUpdate}
          form={'merchant-profile-form'}
          type={selectedComponent}
          initialValues={initialValues}
          placesOptions={places}
          processing={processing}
        />
      </div>
    </div>
  )
}

Profile.propTypes = {
  user: PropTypes.object.isRequired,
  company: PropTypes.string,
  phone: PropTypes.string,
  address: PropTypes.string,
  place: PropTypes.string,
  avatar: PropTypes.string,
  description: PropTypes.string,
  website: PropTypes.string,
  places: PropTypes.array,
  updateProfile: PropTypes.func.isRequired,
  fetchPlaceOptions: PropTypes.func.isRequired,
  processing: PropTypes.bool.isRequired,
}

const mapStateToProps = ({ auth, places }) => ({
  user: pick(auth.user, ['name', 'email', 'id']),
  phone: auth.user.profile ? auth.user.profile.phone : '',
  place: auth.user.profile && auth.user.profile.place ? auth.user.profile.place.slug : 'singapore',
  address: auth.user.profile ? auth.user.profile.address : '',
  avatar: auth.user.profile ? auth.user.profile.avatar : '',
  website: auth.user.company ? auth.user.company.website : '',
  description: auth.user.company ? auth.user.company.description : '',
  places: places.options,
  processing: auth.processing,
})

const mapDispatchToProps = {
  updateProfile: authActions.updateProfile,
  fetchPlaceOptions: placesActions.fetchPlaceOptions,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile)
